import React, { Component } from 'react'
import styled from 'styled-components'
import { imgGridWhite } from '../images'
import { th } from '@smooth-ui/core-sc'

const GridBackground = styled.div`
  background-image: url(${imgGridWhite});
  background-repeat: repeat-x;
  background-position: top;
  background-color: ${th('white')};
  margin: 0;
  padding: 0;
`

class GridBg extends Component {
  render() {
    return <GridBackground>{this.props.children}</GridBackground>
  }
}

export default GridBg
